import { Pipe, PipeTransform } from '@angular/core';

import { AnyDeviceType } from '../models/device-type';

const TRANSLATIONS: Record<AnyDeviceType, string> = {
    mobile: 'UTIL_COMMON.DEVICE_TYPE.MOBILE',
    desktop: 'UTIL_COMMON.DEVICE_TYPE.DESKTOP',
    crossDevice: 'UTIL_COMMON.DEVICE_TYPE.CROSS_DEVICE'
};

/**
 * Returns the translation key for the given device type.
 */
@Pipe({
    name: 'sonaDeviceTypeName',
    standalone: true
})
export class SonaDeviceTypeNamePipe implements PipeTransform {
    transform(category: AnyDeviceType | string): string;
    transform(
        category: AnyDeviceType | string | null | undefined,
    ): string | null;
    transform(
        deviceType: AnyDeviceType | string | null | undefined
    ): string | null {
        if (!deviceType) {
            return null;
        }

        return TRANSLATIONS[deviceType as AnyDeviceType];
    }
}
